import React from 'react'
import styled from 'styled-components'

const SectionWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: auto;
  padding-bottom: 140px;
  @media screen and (max-width: 1023px) {
    padding-bottom: 120px;
  }
  @media screen and (max-width: 800px) {
    padding-bottom: 100px;
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 86%;
  max-width: var(--max-width);
  margin: 0 auto;
  color: var(--text);
  @media screen and (max-width: 800px) {
    width: calc(100% - 50px);
    margin: 0 25px;
  }
`
const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 68%;
  max-width: var(--max-width);
  margin: 0 auto;
  h2.service-title {
    text-align: center;
    margin-bottom: 15px;
  }
  h3.service-subtitle {
    font-size: var(--fz-lg);
    color: var(--text);
    line-height: 1.5;
    text-align: center;
    font-weight: 400;
    margin-bottom: 40px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
  }
`

const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  color: var(--text);
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: 100%;
  }
`

const LeftColumn = styled.div`
  width: calc(50% - 20px);
  margin: 0 20px 0 0;
  padding: 30px;
  border-radius: 10px;
  background-color: var(--black-medium);
  @media screen and (max-width: 1023px) {
    width: calc(50% - 15px);
    margin: 0 15px 0 0;
    padding: 20px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    margin: 0;
  }
`
const RightColumn = styled.div`
  width: calc(50% - 20px);
  margin: 0 0 0 20px;
  padding: 30px;
  border-radius: 10px;
  background-color: var(--black-medium);
  @media screen and (max-width: 1023px) {
    width: calc(50% - 15px);
    margin: 0 0 0 15px;
    padding: 20px;
  }
  @media screen and (max-width: 800px) {
    width: 100%;
    margin: 25px 0 0 0;
  }
`

const ServiceSetup = () => {
  return (
    <SectionWrapper>
      <SectionContainer>
        <HeaderContainer>
          <h2 className="service-title">My setup vs. doing it yourself</h2>
          <h3 className="service-subtitle">Here is a brief overview of the differences between these two approaches.</h3>
        </HeaderContainer>
        <ColumnsContainer>
          <LeftColumn>
            <p>When you hire me as a Shopify expert, I can help you build a store from scratch, customize existing themes and templates, create custom apps, provide ongoing support, and even help you with marketing issues. If you are unsure of the cost of a service, it is best to request a free quote. That will allow you to evaluate and compare the offer to find the best solution for your needs.</p>
          </LeftColumn>
          <RightColumn>
            <p>If you decide to go the DIY route, you must familiarize yourself with the Shopify platform. And you have to learn how to set up payment gateways, create product pages, and integrate third-party services. You'll also need to develop custom themes and templates, manage apps, and provide ongoing support. If you value your time, focus on the business and leave the technical stuff to me.</p>
          </RightColumn>
        </ColumnsContainer>
      </SectionContainer>
    </SectionWrapper>
  )
}

export default ServiceSetup
